import React from 'react';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { TableHeadCell, HeadCell } from './HeadCell';

export interface TableHeadProps {
  columns: TableHeadCell[];
}

const TableHead: React.FC<TableHeadProps> = ({ columns = [] }) => (
  <thead>
    <tr className="ui-table-head-row">
      {columns.map((item) => {
        if (item.isColumnHidden) {
          return null;
        }

        return (
          <th key={`id-table-head-${item.id}`} style={{ width: item.width }}>
            <HeadCell {...item} />
          </th>
        );
      })}
    </tr>
  </thead>
);

export default TableHead;
